import { render } from "./OrganizationView.vue?vue&type=template&id=4197c64a"
import script from "./OrganizationView.vue?vue&type=script&lang=js"
export * from "./OrganizationView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__